import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { parseSampleIdParam } from '@/entities/sample';
import { DialogsPage } from '@/pages/dialogs';
import { SampleSectionProvider } from '../SampleSectionProvider/SampleSectionProvider';
import { SamplesListSection } from '../SamplesListSection/SamplesListSection';

/**
 * Раздел «Выборки» — список диалогов выборки. Собран из той же секции списка и того же детального
 * вида, что и раздел диалогов; своё у раздела — блок выборок, выбор записей и хранение вида по
 * каждой выборке. Пресетов в разделе нет, поэтому адрес с ними не связан.
 *
 * Смена выборки пересоздаёт список: вид и поиск у каждой выборки свои, а состояние поиска берётся
 * из настроек таблицы при создании — иначе в новой выборке осталась бы строка поиска прежней.
 * Состояние раздела живёт над списком, поэтому пересоздание его не задевает.
 */
export const SamplesPage: FC = () => {
  const { sampleId } = useParams<{ sampleId?: string }>();
  const openedSampleId = parseSampleIdParam(sampleId);

  return (
    <SampleSectionProvider>
      <DialogsPage key={openedSampleId ?? ''} listSection={SamplesListSection} presetTableName={null} />
    </SampleSectionProvider>
  );
};
